module.exports = "/_next/static/images/ic_stage-6ebd931571b3d32d1814a3275b5ae9b9.png";